import axios from '../../../../axiosRetailReleases';

const currentURL = window.location.href;
const url = new URL(currentURL);
const domain = url.origin;

// danh sach
const getListAgency = (data, header) => {
    const { status, ...arg } = data;
    return axios({
        url: 'agency/get-list-agency',
        method: 'POST',
        data: {
            ...arg,
            status: Array.isArray(status) ? status : status === -1 || status === null ? [] : [status],
            link: '/stores',
            domain: domain,
        },
        headers: header,
    });
};

// danh sách nhà cung cấp
const getListProvider = (data, header) => {
    const { status, ...arg } = data;
    return axios({
        url: '/agency/get-list-provider',
        method: 'POST',
        data: {
            ...arg,
            status: Array.isArray(status) ? status : status === -1 || status === null ? [] : [status],
            link: '/providers',
            domain: domain,
        },
        headers: header,
    });
};

export { getListAgency, getListProvider }; 
